// Toggle password
attachEvent('.toggle-password', 'click', (ev) => {
  const parentElem = ev.target.closest('.mod-input__inner');
  const passwordInput = parentElem.querySelector('.mod-input__field');
  passwordInput.type = passwordInput.type === 'password' ? 'text' : 'password';
  ev.target.classList.toggle('hide-password');
  ev.preventDefault();
});
